import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 font-[var(--font-mono)] text-[11px] font-medium tracking-[0.02em] transition-colors",
  {
    variants: {
      variant: {
        default: "border-transparent bg-[color:var(--surface-2)] text-[color:var(--text-2)]",
        accent: "border-transparent bg-[color:var(--accent-soft)] text-[color:var(--accent)]",
        secondary: "border-transparent bg-[color:var(--surface-2)] text-[color:var(--text-2)]",
        outline: "border-border bg-transparent text-foreground",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
